<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="row form-page-detail-body-container container-app-search">
    <div
      v-if="!load_first"
      class="d-flex align-items-center justify-content-center"
      style="height: 400px; width: 100%">
      <div class="lds-ellipsis"><div/><div/><div/><div/></div>
    </div>
    <div
      v-if="load_first && !showTable"
      class="d-flex align-items-center justify-content-center"
      style="height: 400px; width: 100%">
      Column not found, please add column first
    </div>
    <div
      v-if="showTable"
      class="table-column">
      <v-server-table
        v-show="load_first"
        ref="recordTableComponent"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @sorted="sortingColumn">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              v-show="showBtnEditData"
              class="btn grey btn-import-form m__r--5"
              @click="openModalData">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-button
              id="filterServerPopover"
              class="btn grey btn-import-form m__r--5">
              <i class="fa fa-filter fa-lg"/> Filter
            </b-button>
            <b-button
              v-show="showBtnEditData"
              class="btn grey btn-import-form m__r--5"
              @click="$refs.appImportRecordModal.show(); dropboxImportShow = true">
              <i class="fa fa-cloud-upload fa-lg"/> Import
            </b-button>
            <b-button
              v-show="showBtnEditData"
              class="btn grey btn-import-form m__r--5"
              @click="exportData">
              <i class="fa fa-download fa-lg"/> Export
            </b-button>
          </b-form>
        </div>

        <div
          v-for="i in Object.values(form_data.columns)"
          slot-scope="props"
          :key="i.id"
          :slot="i.name"
          @click="openDetail(props.row)">
          <div v-if="i.type === 'text' || i.type === 'number'">{{ props.row[i.name] }}</div>
          <div v-if="i.type === 'maps' && props.row[i.name]">{{ props.row[i.name].address }}</div>
          <div v-if="i.type === 'object' && props.row[i.name]">{{ props.row[i.name].name }}</div>
          <div v-if="i.type === '[]text' || i.type === '[]number'">{{ props.row[i.name] ? props.row[i.name].join(', ') : '' }}</div>
          <div v-if="i.type === 'boolean'">{{ props.row[i.name] ? 'TRUE' : 'FALSE' }}</div>
          <div v-if="i.type === '[]object'">
            <span
              v-for="item in props.row[i.name]"
              :key="item.id">{{ item.name }}, </span>
          </div>
          <div v-if="i.type === 'timestamp'">
            <!-- {{ props.row[i.name] ? convertTimestamp(props.row[i.name]) : '' }} -->
            {{ props.row[i.name] }}
          </div>
          <div v-if="i.type === 'person' && props.row[i.name]">
            <div>
              <div class="td">
                <b-img
                  v-if="props.row[i.name].photo"
                  :src="props.row[i.name].photo"
                  rounded="circle"
                  alt="img"
                  class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
                <b-img
                  v-else
                  :src="require('../../assets/logo/user1.png')"
                  rounded="circle"
                  alt="img"
                  class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
              </div>
              <div class="td p__t--7">
                <div>{{ props.row[i.name].email }}</div>
                <div>{{ props.row[i.name].name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div
          slot="delete_and_update"
          slot-scope="props">
          <img
            v-show="showBtnEditData"
            :src="require('@/assets/icon/query/edit.svg')"
            class="cursor-pointer m__r--5"
            width="13"
            @click="openDetail(props.row)">
          <img
            v-if="showBtnEditData && form_data.type !== 'thirdparty'"
            :src="require('@/assets/icon/query/delete.svg')"
            class="cursor-pointer"
            width="13"
            @click="deleteItem(props.row)">
        </div>
      </v-server-table>
    </div>

    <b-popover
      v-if="showTable"
      ref="filterServerPopoverRef"
      :show.sync="popoverFilterServerShow"
      container="form-search-popover"
      target="filterServerPopover"
      placement="top">
      <b-form
        inline
        @keypress.13.prevent="$refs.recordTableComponent.setFilter(filter_data); popoverFilterServerShow = false;">
        <j-single-select
          v-model="select_type"
          :options="options_search"
          :error-required="false"
          placeholder="Filter By"
          label="name"
          class="m__r--5"
          style="width: 200px"/>
        <span
          v-if="cekTypeData(select_type) === 'timestamp'"
          class="reimb-select-period m__r--5">
          <j-datepicker
            v-model="filter_data_start_date"
            :error-required="false"
            placeholder="Start Date"
            format="MMM dd, yyyy"
            class="m__r--5"/>
          <j-datepicker
            v-model="filter_data_end_date"
            :disabled-dates="disableDates(filter_data_start_date)"
            :error-required="false"
            placeholder="End Date"
            format="MMM dd, yyyy"/>
        </span>
        <b-form-input
          v-else
          v-model="filter_data"
          placeholder="Search"
          style="width: 250px !important"/>
      </b-form>
    </b-popover>

    <b-modal
      ref="appAddRecordModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE RECORD</div>
      <j-form-record
        v-if="showRecord"
        ref="jFormCreate"
        :data-fields="dataFields"
        :is-detail="isDetail"/>
      <br>
      <b-row>
        <b-col md="12">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCreateData">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createRecordData">
              Submit
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appEditRecordModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">EDIT RECORD</div>
      <label> JSON </label>
      <j-monaco-editor
        v-if="showCodeEditor"
        ref="scriptEditor"
        :value="jsonData"
        :disable="!showBtnEditData"
        language="json"
        class="m__t--10"
      />
      <br>
      <b-row>
        <b-col md="4">
          <b-button
            v-show="showBtnEditData"
            class="btn red"
            @click="deleteRecordData">
            Delete
          </b-button>
        </b-col>
        <b-col md="8">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeDetail">
              Close
            </b-button>
            <b-button
              v-show="showBtnEditData"
              class="btn blue"
              @click="updateRecordData">
              Update
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appImportRecordModal"
      class="mod-form modal-add-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">IMPORT</div>
      <div
        v-if="dropboxImportShow"
        class="dropbox-oos">
        <input
          type="file"
          multiple
          class="input-file"
          @change="handleFileUpload($event.target.files)">
        <img :src="require('@/assets/form-data/file-dropbox.png')">
        <div class="label-dropbox">Drop your file here, or <span>browse</span></div>
        <div class="label-support-dropbox">Support : ZIP</div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeImportForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import jApiForm from '@/services/jApiForm';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import Vue from 'vue';

import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  // eslint-disable-next-line
  components: {
    jMonacoEditor,
  },
  data() {
    return {
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      popoverFilterServerShow: false,
      select_type: null,
      options_search: [],
      filter_data: '',
      filter_data_start_date: null,
      filter_data_end_date: null,
      jsonData: '',
      idRecord: '',
      darkMode: false,
      isDetail: false,
      showRecord: false,
      load_first: false,
      dropboxImportShow: false,
      showCodeEditor: false,
      showTable: false,
      columnSort: null,
      dataFields: [],
      data_table: [],
      columns: [],
      table_options: {
        headings: {},
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],

        requestAdapter(data) {
          return {
            limit: data.limit,
            page: data.page,
            filter: data.filter,
            sort: data.sort,
          };
        },
        requestFunction(data) {
          const list = jApiForm.getListRecordByFormDataId(data);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.count ? data.count : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreForm', ['form_id', 'form_data', 'privilege_by_me']),

    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },

    showBtnEditData() {
      return this.isAdmin || (this.privilege_by_me.includes('edit_data') && !this.privilege_by_me.includes('view_only'));
    },
  },
  watch: {
  },
  created() {
    if (this.form_data) {
      const reqTable = {
        tablegroup_id: this.$route.params.id,
        search: this.form_data.id,
      };
      this.findListTableByGroup(reqTable).then((res) => {
        if (res.data && res.data.length > 0) {
          const dataForm = res.data.find(f => f.id === this.form_data.id);
          this.actionSetFormData(dataForm);
          this.definedColumnTable();
        }
      });
    }
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreForm', ['createRecord', 'deleteRecord', 'findForm', 'actionSetFormData', 'findListTableByGroup']),

    exportData() {
      this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
      const token = Vue.ls.get('Token');
      const gateUrl = localStorage.getItem('gateUrl');
      const url = `${gateUrl}nocode/record/export-zip`;
      const params = {
        form_data_id: this.form_id,
      };

      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }).then((res) => {
        this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
        const a = document.createElement('a');
        const urlBlob = window.URL.createObjectURL(res.data);

        const date = new Date();
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        const fileName = `${this.form_data.name}_${years}-${mounth}-${dates}.zip`;

        a.href = urlBlob;
        a.download = fileName;
        a.click();
      });
    },

    handleFileUpload(file) {
      console.log(file);
      if (file[0].type.includes('zip')) {
        this.$swal({
          title: 'IMPORT',
          text: `Are you sure to import file ${file[0].name} ?`,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
            const token = Vue.ls.get('Token');
            const formData = new FormData();
            const gateUrl = localStorage.getItem('gateUrl');
            const url = `${gateUrl}nocode/record/import-zip?form_data_id=${this.form_id}&token=${token}`;

            formData.append('file', file[0]);

            axios.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
            ).then(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Success Import Data');
              this.$refs.recordTableComponent.refresh();
              this.closeImportForm();
            }).catch(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Error Import Data');
            });
          } else {
            this.dropboxImportShow = false;
            setTimeout(() => {
              this.dropboxImportShow = true;
            }, 100);
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'File not support');
      }
    },

    closeImportForm() {
      this.$refs.appImportRecordModal.hide();
      this.dropboxImportShow = false;
    },

    disableDates(date) {
      if (date) {
        return {
          to: new Date(date - 8640000),
        };
      }
      return {};
    },

    cekTypeData(key) {
      if (key === '') { return ''; }
      if (key === null) { return ''; }
      const findType = this.form_data.columns[key];
      return findType ? findType.type : '';
    },

    convertTimestamp(data) {
      const date = new Date(data);
      const years = date.getFullYear();
      const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      return `${years}-${mounth}-${dates}`;
    },

    definedColumnTable() {
      if (this.form_data.columns) {
        const dataColumns = Object.values(this.form_data.columns);
        dataColumns.forEach((e) => {
          this.columns.push(e.name);
          this.table_options.headings[e.name] = e.name;
          this.table_options.sortable.push(e.name);
        });
        this.columns.push('delete_and_update');
        this.table_options.headings.delete_and_update = 'action';
        this.showTable = true;

        this.options_search = [];
        dataColumns.forEach((e) => {
          if (e.type === 'object') {
            this.options_search.push({
              text: `${e.name} - ID`,
              name: `${e.name} - ID`,
              value: `${e.name}.id`,
              id: `${e.name}.id`,
            });
            this.options_search.push({
              text: `${e.name} - Name`,
              name: `${e.name} - Name`,
              value: `${e.name}.name`,
              id: `${e.name}.name`,
            });
          } else if (e.type === 'person') {
            this.options_search.push({
              text: `${e.name} - Company User ID`,
              name: `${e.name} - Company User ID`,
              value: `${e.name}.company_user_id`,
              id: `${e.name}.company_user_id`,
            });
            this.options_search.push({
              text: `${e.name} - Name`,
              name: `${e.name} - Name`,
              value: `${e.name}.name`,
              id: `${e.name}.name`,
            });
            this.options_search.push({
              text: `${e.name} - Email`,
              name: `${e.name} - Email`,
              value: `${e.name}.email`,
              id: `${e.name}.email`,
            });
          } else if (e.type === 'timer') {
            this.options_search.push({
              text: `${e.name} - State`,
              name: `${e.name} - State`,
              value: `${e.name}.state`,
              id: `${e.name}.state`,
            });
            this.options_search.push({
              text: `${e.name} - Duration`,
              name: `${e.name} - Duration`,
              value: `${e.name}.duration`,
              id: `${e.name}.duration`,
            });
          } else if (e.type === 'tags') {
            this.options_search.push({
              text: `${e.name} - Name`,
              name: `${e.name} - Name`,
              value: `${e.name}.name`,
              id: `${e.name}.name`,
            });
          } else {
            this.options_search.push({
              text: e.name,
              name: e.name,
              value: e.name,
              id: e.name,
            });
          }
        });
      } else {
        this.load_first = true;
      }
    },

    loading(val) {
      const a = val;
      const dataFilter = {};

      let x;
      // eslint-disable-next-line
      const _user = this.session.user;

      if ((this.filter_data || (this.filter_data_start_date && this.filter_data_end_date)) && this.select_type) {
        if (this.cekTypeData(this.select_type) === 'timestamp') {
          const startDate = this.$moment(this.filter_data_start_date).format('YYYY-MM-DD');
          const endDate = this.$moment(this.filter_data_end_date).format('YYYY-MM-DD');
          const startOfDay = new Date(Date.parse(`${startDate} 00:00:00`)).getTime();
          const endOfDay = new Date(Date.parse(`${endDate} 23:59:59`)).getTime();
          // eslint-disable-next-line
          dataFilter[this.select_type] = { '$between': [startOfDay, endOfDay] };
        } else {
          // eslint-disable-next-line
          if (this.cekTypeData(this.select_type) === 'number') {
            dataFilter[this.select_type] = Number(this.filter_data);
          } else {
            dataFilter[this.select_type] = this.filter_data;
          }
        }
      }
      const lengthDataFilter = Object.keys(dataFilter);
      const defaultSort = lengthDataFilter.length === 0 ? { _id: -1 } : {};

      a.form_data_id = this.form_id;
      a.filter = dataFilter;
      a.sort = this.columnSort || defaultSort;

      if (this.load_first) {
        this.showLoading();
      }
    },
    loaded(data) {
      this.data_table = data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeCreateData() {
      this.$refs.appAddRecordModal.hide();
      this.showRecord = false;
    },

    createRecordData() {
      this.$refs.jFormCreate.getData().then((params) => {
        const dataColumns = Object.values(this.form_data.columns);
        const data = {
          form_data_id: this.form_id,
          data: {},
        };
        dataColumns.forEach((e) => {
          const findValue = params.find(f => f.name === e.name);
          if (e.type === 'number') {
            data.data[e.name] = findValue.value ? Number(findValue.value) : 0;
          } else if (e.type === 'text') {
            data.data[e.name] = findValue.value ? findValue.value : '';
          } else if (e.type === 'timestamp') {
            data.data[e.name] = findValue.value ? new Date(Date.parse(findValue.value)).getTime() : 0;
          } else if (e.type === 'boolean') {
            data.data[e.name] = false;
          } else if (e.type === '[]text' || e.type === '[]number' || e.type === '[]object' || e.type === '[]attachment' || e.type === '[]tags') {
            data.data[e.name] = [];
          } else if (e.type === 'object') {
            data.data[e.name] = {
              id: '',
              name: '',
            };
          } else if (e.type === 'maps') {
            data.data[e.name] = {
              latitude: 0,
              longitude: 0,
              address: '',
            };
          } else if (e.type === 'timer') {
            data.data[e.name] = {
              log: [],
              state: '',
              duration: 0,
            };
          } else if (e.type === 'tags') {
            data.data[e.name] = {
              name: '',
              background: '',
              font_color: '',
            };
          } else {
            data.data[e.name] = null;
          }
        });
        // eslint-disable-next-line
        this.createRecord(data).then((response) => {
          this.$refs.recordTableComponent.refresh();
        });
      });
      this.$refs.appAddRecordModal.hide();
      this.showRecord = false;
    },

    updateRecordData() {
      const json = typeof this.$refs.scriptEditor !== 'undefined' ? this.$refs.scriptEditor.getData().trim() : '';
      const data = {
        form_data_id: this.form_id,
        data: JSON.parse(json),
      };

      this.createRecord(data).then((response) => {
        this.$refs.recordTableComponent.refresh();
        this.$refs.appEditRecordModal.hide();
        this.showCodeEditor = false;
      });
    },

    openModalData() {
      this.dataFields = [];
      this.isDetail = false;
      const dataColumns = Object.values(this.form_data.columns);
      const dataType = ['text', 'number', 'timestamp'];
      const dataFields = [];
      let idField = 1;
      dataColumns.forEach((e) => {
        dataFields.push(
          {
            attendance_data: null,
            available_list: [],
            available_list_autofilled: false,
            camera_use_type: 0,
            custom_formula: [],
            formula: null,
            group_form_id: '',
            groups: [],
            id: idField,
            is_back_date: true,
            is_can_access_gallery: false,
            is_can_similar: false,
            is_delete: !dataType.includes(e.type),
            is_editable: true,
            is_mandatory: false,
            key: '',
            map_type: 1,
            multiple_value: [],
            name: e.name,
            order_id: 1,
            placeholder: '',
            relation_record_form: null,
            relation_record_form_id: 0,
            relation_record_form_name: '',
            source_id: 0,
            type: e.type === 'timestamp' ? 'date_time' : e.type,
            value: '',
            value_form: null,
          },
        );
        // eslint-disable-next-line
        idField++;
      });
      this.dataFields = dataFields;
      this.$refs.appAddRecordModal.show();
      this.showRecord = true;
    },

    openDetail(data) {
      this.idRecord = data.id;
      this.jsonData = JSON.stringify(data, null, 4);
      this.$refs.appEditRecordModal.show();
      setTimeout(() => { this.showCodeEditor = true; }, 500);
    },

    closeDetail() {
      this.$refs.appEditRecordModal.hide();
      this.showCodeEditor = false;
    },

    deleteItem(data) {
      this.$swal({
        title: 'Delete Form',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const params = {
            id: data.id,
            form_data_id: this.form_id,
          };
          // eslint-disable-next-line
          this.deleteRecord(params).then((response) => {
            this.$refs.recordTableComponent.refresh();
          });
        }
      });
    },

    deleteRecordData() {
      this.$swal({
        title: 'Delete Form',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const params = {
            id: this.idRecord,
            form_data_id: this.form_id,
          };
          // eslint-disable-next-line
          this.deleteRecord(params).then((response) => {
            this.$refs.recordTableComponent.refresh();
            this.$refs.appEditRecordModal.hide();
            this.showCodeEditor = false;
          });
        }
      });
    },

    sortingColumn(val) {
      const { column, ascending } = val;
      const columnType = this.form_data.columns[column].type;

      if (columnType === 'object' || columnType === 'person' || columnType === 'tags') {
        const key = `${column}.name`;
        this.columnSort = {
          [key]: ascending ? 1 : -1,
        };
      } else {
        this.columnSort = {
          [column]: ascending ? 1 : -1,
        };
      }
    },
  },
  validations() {
    return {
    };
  },
};
</script>

<style lang="scss">
  .form-page-detail-body-container {
    // background-color: #ffffff;
    overflow: auto;
    margin: 1px;
    // height: 100%;
  }

  .table-column .jTable {
    width: 95%;
    margin-left: 15px;
  }

  .modal-add-record-data .modal-dialog {
    max-width: 800px !important;
  }

  @media only screen and (max-height: 855px) {
    .table-column {
      // max-height: 550px;
      width: 100%;
    }
  }
  @media only screen and (min-height: 856px) {
    .table-column {
      // max-height: 650px;
      width: 100%;
    }
  }

  .my-editor {
    font-family: 'Poppins-Regular';
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
    border: 1px solid #D8D8D8;
  }

  .dark-mode {
    background: #2d2d2d;
  }

  .dark-mode .prism-editor__editor {
    color: #ccc !important;
  }

  .prism-editor__textarea:focus {
    outline: none;
  }

  .prism-editor__editor span{
    font-size: inherit !important;
  }

  .prism-editor__editor {
    color: #5c5b5b;
  }

  .jTable .VuePagination {
    margin-top: 15px;
  }

  .jSelectSingle.vue-treeselect .vue-treeselect__menu-container .vue-treeselect__menu .vue-treeselect__list .vue-treeselect__list-item .vue-treeselect__option .vue-treeselect__label-container .vue-treeselect__label {
    text-align: left !important;
    float: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/data-manager/jFormData.vue